import { makeStyles, Subtitle1, tokens } from '@fluentui/react-components';
import type { ComponentProps, ReactNode, Ref } from 'react';

const useStyles = makeStyles({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    ':focus-visible': {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: '2px',
    },
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
  },
});

type TProps = {
  title: string;
  children: ReactNode;
  id?: string;
  sectionRef?: Ref<HTMLDivElement>;
  tabIndex?: ComponentProps<'div'>['tabIndex'];
};

const DashboardSection = ({ title, children, id, sectionRef, tabIndex }: TProps) => {
  const classes = useStyles();
  const headingId = id ? `${id}-heading` : undefined;

  return (
    <div ref={sectionRef} id={id} className={classes.section} aria-labelledby={headingId} tabIndex={tabIndex}>
      <div className={classes.sectionHeader}>
        <Subtitle1 id={headingId}>{title}</Subtitle1>
      </div>
      {children}
    </div>
  );
};

export default DashboardSection;
